/* eslint-disable import/prefer-default-export */
const formatCountryCodesToString = (countryCodes: string[], countryCodeMap: { [key: string]: string }) => {
  let countryNames: string[] = [];
  if (countryCodes) {
    countryNames = countryCodes.map((c) => countryCodeMap[c]);
  }

  if (countryNames.length > 2) {
    const firstTwoCountries = countryNames.slice(0, 2).join(' and ');
    return `${firstTwoCountries} and ${countryNames.length - 2}+`;
  }

  return countryNames.join(' and ');
};

export { formatCountryCodesToString };
